import { json } from '@remix-run/node';

import { B2BLandingPage } from '@modules/b2b/B2BLandingPage';
import { brandsConfig } from '@modules/b2b/config/brands.config';
import {
    createMetaDescription,
    createMetaTitle,
    createOGTags,
    mergeMeta,
} from '~/modules/seo';
import { B2B_CANONICAL_ORIGIN } from '~/utils/business-subdomain';

/**
 * Brands landing page served at `business.archiproamerica.com/brands` via
 * the edge rewrite to `/b2b/brands`. Renders the same `B2BLandingPage` +
 * `brandsConfig` as `_app.business-brands.tsx` — content lives in the b2b
 * module, this file is just the route binding + canonical URL.
 *
 * The host guard + `handle` (hide nav/footer/chat/search) live on the
 * `b2b.tsx` layout so every B2B route inherits them.
 */
export const loader = () =>
    json({
        title: brandsConfig.meta.title,
        description: brandsConfig.meta.description,
    });

export const meta = mergeMeta<typeof loader>(
    () => [],
    (props) => {
        const { data } = props;
        const title = createMetaTitle(props, [data?.title, 'ArchiPro']);
        const description = createMetaDescription([data?.description ?? '']);
        return [
            { title },
            { name: 'description', content: description },
            ...createOGTags({ meta: props, title, description }),
            {
                tagName: 'link',
                rel: 'canonical',
                href: `${B2B_CANONICAL_ORIGIN}/b2b/brands`,
            },
        ];
    },
);

export default function B2BBrandsRoute() {
    return <B2BLandingPage config={brandsConfig} />;
}
